


























































import { Component, Vue } from 'vue-property-decorator'
import { readFile } from '@/helpers/file'
import { ITutorialSlide } from '@/components/Tutorial.vue'
import { TRACKMATCHING_METHODS } from '@/store/modules/trackmatching'
import { SPOTIFY_PLAYLIST_REGEX } from '@/constants'

@Component({
  components: {
    IconCard: require('@/components/IconCard').default,
    Tutorial: require('@/components/Tutorial').default,
    ShazamLocalCharts: require('./Sources/ShazamLocalCharts').default,
    PasteText: require('./Sources/PasteText').default,
    SpotifyPlaylist: require('./Sources/SpotifyPlaylist').default,
    TidalPlaylist: require('./Sources/TidalPlaylist').default
  }
})
export default class Choice extends Vue {
  file: File | null = null

  tutorialSlides: ITutorialSlide[] = [
    {
      html: `With the <i>Track Matcher</i> you can give rekordcloud a list of tracks and rekordcloud will search your library for matching tracks. You can save these tracks as a new playlist. Tracks are found by <i>fuzzy searching</i> - this means your list doesn't need to be exact and can even contain typo's.<br>This is ideal if you get a list of tracks from your client so you don't need to search by hand anymore.<br><br>In this tutorial I'm going to quickly walk through how the Track Matcher works.`
    },
    {
      image: 'trackmatcher1.png',
      html: `First thing I need to do is give the Track Matcher something to work with. I can upload a text file or just paste it. Above, you can see the text I used.<br><br>You'll probably notice there are some pretty big typo's in there (it should be <i>Krooked, Empire and Drizzle</i>). If you've ever received a list from your clients, you'll know that correct spelling isn't their top priority. No problem, since the Track Matcher can handle typo's.`
    },
    {
      image: 'trackmatcher2.png',
      html: `In the next screen, rekordcloud shows how it's reading the text. In this case, I'm leaving the separator on the standard - (dash).<br><br>Now all I have to do is confirm and rekordcloud is going to scan and match my entire library. My library isn't so big so it won't take long.`
    },
    {
      image: 'trackmatcher3.png',
      html: `The results look much better than the text I uploaded! Rekordcloud found all tracks regardless of the pretty bad typo's.<br>You'll see variations of tracks here too and you can show more columns like rating or color to help you choose the right track. Then it's just one click and the tracks are in a new playlist.<br><br>That's the end of the tutorial. The Track Matcher can replace the search you'd otherwise do by hand and save you lots of time. You don't need to be afraid of long lists of badly spelled tracks anymore!`
    }
  ]

  async onSpotifyDragdrop(e: DragEvent) {
    e.stopPropagation()
    e.preventDefault()

    if (e.dataTransfer) {
      const text = e.dataTransfer.getData('text/plain')

      if (text && SPOTIFY_PLAYLIST_REGEX.test(text)) {
        (this.$refs as any).spotifyPlaylist.open(text)

        await (this.$refs as any).spotifyPlaylist.confirm()
      }
    }
  }

  async loadFile() {
    if (!this.file) return

    let text: string = ''

    if (this.file.name.toLowerCase().endsWith('.txt')) {
      text = await readFile(this.file)
    } else if (this.file.name.toLowerCase().endsWith('.m3u') || this.file.name.toLowerCase().endsWith('.m3u8')) {
      const playlistText = await readFile(this.file)

      text = playlistText
        .split(/\r|\n/)
        .map(x => x.trim())
        .filter(x => !!x && !x.startsWith('#'))
        .map(x => (x.includes('/') ? x.split('/') : x.split('\\')).slice(-1)[0].split('.')[0])
        .join('\n')
    } else {
      this.$buefy.dialog.alert({
        title: 'Invalid file',
        message: 'Please upload a .txt file with a new track on each line.'
      })

      this.file = null

      return
    }

    this.$store.commit('trackmatching/setMethod', TRACKMATCHING_METHODS.Text)
    this.$store.commit('trackmatching/setSeparator', null)
    this.$store.commit('trackmatching/setText', text) // Save to storage so it autofils when going to paste text
    this.$store.commit('trackmatching/parseText', text)
    this.$store.commit('trackmatching/setShowInputControls', true)

    await this.$router.push({
      name: 'trackmatching parsed'
    })
  }
}
